import {brandConfigObjectMap, Brands} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig(Brands.BattleLeaugeGamingMFilter));
brandConfigMap.set('https://ke-play.yellowrush.co.za', getBrandConfig(Brands.RushGames));
brandConfigMap.set('https://ke-play.fantasyfootball.one', getBrandConfig(Brands.FantasySoccer));
brandConfigMap.set('https://ke-play.blg.gg', getBrandConfig(Brands.BattleLeaugeGaming));
brandConfigMap.set('https://ke-mplay.blg.gg', getBrandConfig(Brands.BattleLeaugeGamingMFilter));
brandConfigMap.set('https://ke-mplay.yellowrush.co.za', getBrandConfig(Brands.RushGamesMFilter));
brandConfigMap.set('https://ke-mplay.fantasyfootball.one', getBrandConfig(Brands.FantasySoccerMFilter));
brandConfigMap.set('https://rgs-gr-wr.goodgamingco.com', getBrandConfig(Brands.GameRushMFilter));
brandConfigMap.set('https://rgs-gaw-wr.goodgamingco.com', getBrandConfig(Brands.GameAppWorldMFilter));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        assetBrand: brandConfigObject?.assetBrand ?? brand,
        ...brandConfigObject
    }
}
